import { IsNotEmpty, IsString } from 'class-validator';

export class DispositivoCriarDto {
  @IsString()
  @IsNotEmpty()
  token: string;

  navegador: string;
}
